export default {
    calendar: {
        create: {
            task: 'Новая задача',
            sotrmeet_title: 'Запланировать событие',
            task_title: 'Поставить задачу',
            startTime: 'Время начала',
            endTime: 'Время окончания',
            event: 'Событие',
            priority: 'Приоритет',
            done: 'Выполнено',
            alarm: 'Предупредить'
        },
        edit_task: 'Редактировать задачу',
        edit_sotrmeet: 'Редактировать событие',
        description: 'Описание',
        show_in_planner: 'Отображать в планере',
        own_event: 'Личное событие',
        time: 'Время',
        date: 'Дата',
        date_from: 'Дата с',
        date_to: 'Дата по',
        today: 'Сегодня',
        day: 'День',
        week7: 'Неделя 7',
        week5: 'Неделя 5',
        events: 'События',
        tasks: 'Задачи',
        personal: 'Личное',
        conversations: 'Разговоры',
        meetings: 'Встречи',
        planner: 'Планер',
        education: 'Обучение',
        no_events: 'Нет событий',
        no_tasks: 'Нет задач',
        filtersNotSelected: 'Нет выбранных фильтров',
        show_completed_tasks: 'Показывать выполненные задачи',
        whole_day: 'весь день',
        education_event: 'Событие обучения',
        no_education_events: 'Нет событий обучения',
        task_list_headers: {
            date: 'Дата',
            description: 'Описание',
            priority: 'Приоритет',
            done: 'Выполнено'
        },
        education_events_fields: {
            name: 'Имя',
            project: 'Проект',
            people: 'Контакт',
            date: 'Дата мероприятия',
            time: 'Время мероприятия',
            place: 'Место',
            trainers: 'Список тренеров'
        }
    }
};
